import {Button, Group, Modal, Stack, Text, TextInput} from '@mantine/core'

import {copyDriverLinkToClipboard} from './copy-driver-job-link'
import type {DriverLink} from './schemas'

export function DriverLinksDialog({
    links,
    onClose,
}: {
    links: DriverLink[] | null
    onClose: () => void
}) {
    return (
        <Modal opened={links != null} onClose={onClose} title="Driver links">
            <Stack gap="sm">
                {links?.length === 0 ? (
                    <Text size="sm">
                        No drivers assigned to this job. Assign them on the dispatch board.
                    </Text>
                ) : (
                    <Text size="sm">Send each driver only their own link.</Text>
                )}
                {links?.map((link) => (
                    <Group key={link.workerId} align="flex-end" wrap="nowrap" gap="xs">
                        <TextInput
                            label={link.workerName}
                            value={link.url}
                            readOnly
                            style={{flex: 1}}
                            onFocus={(event) => event.currentTarget.select()}
                        />
                        <Button
                            variant="default"
                            onClick={() => void copyDriverLinkToClipboard(link)}
                            aria-label={`Copy link for ${link.workerName}`}
                        >
                            Copy link
                        </Button>
                    </Group>
                ))}
                <Group justify="flex-end">
                    <Button onClick={onClose}>Done</Button>
                </Group>
            </Stack>
        </Modal>
    )
}
